/* Text examples only. Product-specific options stay on their product pages. */
(() => {
  const desktop = matchMedia('(min-width:768px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const slides = [...root.querySelectorAll('.efdoors-options__slides > span')];
    const control = root.querySelector('.efdoors-options__control');
    if (slides.length < 2 || !control) return;
    const firstLabel = slides[0].textContent;
    let index = 0, timer = null, paused = false, hovered = false, completed = false;
    function label() {
      const action = completed ? 'Replay' : paused ? 'Play' : 'Pause';
      control.textContent = action;
      control.setAttribute('aria-label', action + ' customization examples');
    }
    function show(next) {
      slides[index].classList.remove('is-current');
      index = next;
      slides[index].classList.add('is-current');
    }
    function schedule() {
      clearTimeout(timer); timer = null;
      const enabled = desktop.matches && !reduced.matches;
      root.dataset.active = String(enabled);
      label();
      if (!enabled || paused || hovered || completed || document.hidden || !root.isConnected) return;
      timer = setTimeout(() => {
        if (index === slides.length - 1) {
          completed = true;
          slides[0].textContent = 'Finishes · Door style · Glass · Details';
          show(0);
        } else show(index + 1);
        schedule();
      }, 2500);
    }
    control.addEventListener('click', () => {
      if (completed) { completed = false; paused = false; slides[0].textContent = firstLabel; show(0); }
      else paused = !paused;
      schedule();
    });
    root.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') { hovered = true; schedule(); } });
    root.addEventListener('pointerleave', () => { hovered = false; schedule(); });
    // Keyboard interaction stops rotation until explicitly resumed.
    root.addEventListener('focusin', event => { if (event.target.matches(':focus-visible')) { paused = true; schedule(); } });
    document.addEventListener('visibilitychange', schedule);
    desktop.addEventListener('change', schedule);
    reduced.addEventListener('change', schedule);
    schedule();
  }
  function scan(scope = document) { scope.querySelectorAll('[data-ef-doors-options]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), {once:true}); else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
